import { render, staticRenderFns } from "./InvestList.vue?vue&type=template&id=3851304d&scoped=true&"
import script from "./InvestList.vue?vue&type=script&lang=js&"
export * from "./InvestList.vue?vue&type=script&lang=js&"
import style0 from "./InvestList.vue?vue&type=style&index=0&id=3851304d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3851304d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
